<template>
  <div class="base-table">
    <div class="base-table-table">
      <el-table
        ref="myTable"
        :data="tableList"
        style="width: 100%"
        stripe
        :cell-class-name="addClass"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" />
        <template v-for="(item, index) in tableHeader">
          <el-table-column
            :prop="item.prop"
            :label="item.label"
            :align="'left'"
            :key="index"
            :width="item.width ? item.width : null"
          >
            <template slot-scope="scope">
              <div v-if="item.label == '租户登录链接'">
                <div class="copy">
                  <p class="httpLink bianque_man">
                    运营管理端:
                    <span ref="bianque_man">
                      https://bianque-man.jd.com/index/?logintype=&tenantId={{
                        scope.row[item.prop]
                      }}
                    </span>
                  </p>
                  <!-- <span> -->
                  <el-button
                    type="text"
                    size="small"
                    @click="bianque_man('bianque_man', scope.$index)"
                    class="but"
                    >复制</el-button
                  >
                  <!-- </span> -->
                </div>
                <div class="copy">
                  <p class="httpLink bianque">
                    创作者端:
                    <span ref="bianque">
                      https://bianque.jd.com/index/?tenantId={{
                        scope.row[item.prop]
                      }}
                    </span>
                  </p>
                  <!-- <span> -->
                  <el-button
                    type="text"
                    size="small"
                    @click="bianque_man('bianque', scope.$index)"
                    class="but"
                    >复制</el-button
                  >
                  <!-- </span> -->
                </div>
              </div>
              <div v-else-if="item.label == '创建时间'">
                <p>{{ scope.row[item.prop] | timeTransform }}</p>
              </div>
            </template>
          </el-table-column>
        </template>
        <template v-if="tableType !== 0">
          <el-table-column align="center" label="操作" width="150">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="small">{{
                  scope.row.isFeatured ? "取消精选" : "精选"
                }}</el-button>
              </div>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
  </div>
</template>

<script>
var env_mode = process.env.TYPE;
import { jdh_qz_man_post_change } from "@/api/indexs";
import { getBusinessId } from "../../../../utils/enum"
// import images from "../assets/";
export default {
  name: "circleTable",
  props: {
    tableData: {
      default: () => {
        return {
          tableList: Array, // 列表
          tableHeader: Array, // 表头
          tableType: Number, // 操作按钮
          shuType: Number,
        };
      },
    },
    isFreezeShow: {
      default: () => {
        return true;
      },
      type: Boolean,
    },
    activeName: {
      default: () => {
        return "";
      },
      type: String,
    },
    mulSelect: {
      default: () => {
        return false;
      },
      type: Boolean,
    },
  },
  // [ 'tableData' ],
  data() {
    return {
      images: "../assets/default-header.png",
      selectedRows: [],
      tableList: [],
      tableHeader: [],
      tableType: "",
      shuType: "",
      env_mode,
    };
  },
  mounted() {},
  methods: {
    getBusinessId(key) {
      return getBusinessId(key)
    },
    // 表格多选
    handleSelectionChange(val) {
      console.log(val, this);
    },
    created() {
      console.log("tableList", this.tableData);
      if (this.tableData) {
        var { tableList, tableHeader, tableType, shuType, general } =
          this.tableData;
        console.log("tableHeader", tableHeader);
      }
      this.tableList = tableList || [];
      this.tableHeader = tableHeader || [];
      this.tableType = tableType || 0;
      this.shuType = shuType;
    },
  },
};
</script>

<style scoped lang="scss">
.httpLink {
  width: 152px;
  font-size: 12px;
  color: #5d6072;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.copy {
  display: flex;
  align-items: center;

  .but {
    width: 24px;
  }

  .httpLink {
    flex: 1;
  }
}

.images {
  width: 50px;
  height: 50px;

  // margin: 0 auto;
  & > img {
    border-radius: 50%;
    width: 100%;
    height: 100%;
  }
}

.badge {
  color: red;
}

.choiceness {
  color: #fff;
  background-color: red;
}

.noColor {
  color: #c0c4cc;
}

.cell {
  font-size: 13px;
  color: rgba(93, 96, 114, 1);
  overflow: visible !important;
}

.confirmBtnBox {
  padding: 20px 0;
  display: flex;
  justify-content: flex-end;
}

.inputSort {
  width: 100%;
}
</style>
